import React from 'react';
import PropTypes from 'prop-types';

import { CloseButtonContainer } from './CloseButtonComponentStyle';

class CloseButtonComponent extends React.Component {
    render() {
        return <CloseButtonContainer onClick={this.props.onClick}>x</CloseButtonContainer>;
    }
}

CloseButtonComponent.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default CloseButtonComponent;



// WEBPACK FOOTER //
// ./src/components/button/CloseButtonComponent.js